module.exports = __webpack_public_path__ + "img/kaifa.6edb1b65.jpg";